{
  document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".counter_animation");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const originalText = el.innerText.trim();
            const isPercent = originalText.includes("%");
            const numericValue = parseFloat(originalText);

            gsap.fromTo(
              el,
              { innerText: 0 },
              {
                innerText: numericValue,
                duration: 2,
                ease: "power1.out",
                snap: { innerText: 1 },
                onUpdate: () => {
                  el.textContent =
                    Math.round(el.innerText) + (isPercent ? "%" : "");
                },
              }
            );

            observer.unobserve(el);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    counters.forEach((counter) => observer.observe(counter));
  });
}
// {
//   document.addEventListener("DOMContentLoaded", function () {
//     const headings = document.querySelectorAll(".animates_text");

//     headings.forEach((heading) => {
//       const originalText = heading.textContent.trim();
//       if (!originalText) return;

//       heading.style.opacity = "1";

//       const words = originalText.split(/\s+/);
//       const fragment = document.createDocumentFragment();

//       words.forEach((word, index) => {
//         const span = document.createElement("span");
//         span.className = "word";
//         span.style.opacity = "0";
//         span.style.display = "inline-block";
//         span.textContent = word;
//         fragment.appendChild(span);
//         if (index < words.length - 1)
//           fragment.appendChild(document.createTextNode(" "));
//       });

//       heading.innerHTML = ""; // Clear existing text
//       heading.appendChild(fragment);
//     });

//     const observer = new IntersectionObserver(
//       (entries, observerInstance) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const wordSpans = entry.target.querySelectorAll(".word");
//             gsap.fromTo(
//               wordSpans,
//               { opacity: 0, y: 50 },
//               {
//                 opacity: 1,
//                 y: 0,
//                 duration: 0.8,
//                 ease: "power3.out",
//                 stagger: 0.1,
//               }
//             );
//             observerInstance.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.5 }
//     );

//     headings.forEach((heading) => observer.observe(heading));
//   });
// }
{
  document.addEventListener("DOMContentLoaded", function () {
    const charts = document.querySelectorAll(".circular-chart");
    charts.forEach((chart) => {
      const text = chart.querySelector(".percentage");
      const circle = chart.querySelector(".circle");
      if (text && circle) {
        const percentage = parseInt(text.textContent);
        const dashArray = `${percentage}, 100`;
        circle.style.strokeDasharray = dashArray;
        circle.classList.add("animate");
      }
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    function isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom >= 0;
    }
    function checkProgressWrpInView() {
      const sections = document.querySelectorAll(
        ".propgres-Wrp:not(.activeport)"
      );
      sections.forEach((section) => {
        if (isInViewport(section)) {
          section.classList.add("activeport");
          section.querySelectorAll(".progress-bar-area").forEach((bar) => {
            bar.style.width = bar.dataset.width;
          });
        }
      });
    }
    window.addEventListener("scroll", checkProgressWrpInView);
    window.addEventListener("load", checkProgressWrpInView);
  });

  // news
  document.addEventListener("DOMContentLoaded", function () {
    function countview(element) {
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom >= 0;
    }
    function countwrpnew() {
      const sections = document.querySelectorAll(
        ".counter-box:not(.activeCount)"
      );
      sections.forEach((section) => {
        if (countview(section)) {
          section.classList.add("activeCount");
        }
      });
    }
    window.addEventListener("scroll", countwrpnew);
    window.addEventListener("load", countwrpnew);
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    Chart.register(ChartDataLabels);

    const spanVal = document
      .querySelector(".pie-chart-val")
      .getAttribute("data-values");

    const dataValues = JSON.parse(spanVal);
    const total = dataValues.reduce((a, b) => a + b, 0);

    const ctx = document.getElementById("myPieChart").getContext("2d");
    const myPieChart = new Chart(ctx, {
      type: "pie",
      data: {
        // labels: ["Red", "Blue", "Yellow"], // optional
        datasets: [
          {
            label: "Dogs",
            data: dataValues,
            backgroundColor: ["#4DC7F4", "#00AEEF", "#B3E7FB", "#CCEFFC"],
            hoverOffset: 10,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom",
          },
          datalabels: {
            color: "#111111",
            font: {
              weight: "700",
              size: 15,
            },
            formatter: (value, context) => {
              let percentage = ((value / total) * 100).toFixed(1) + "%";
              return percentage;
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    Chart.register(ChartDataLabels);
    const dataValues = [8, 64, 28];
    const total = dataValues.reduce((a, b) => a + b, 0);
    const ctx = document.getElementById("ownerChart").getContext("2d");
    const myPieChart = new Chart(ctx, {
      type: "pie",
      data: {
        datasets: [
          {
            label: "Dogs",
            data: dataValues,
            backgroundColor: ["#F24DAF", "#EC008C", "#FAB3DD"],
            hoverOffset: 10,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom",
          },
          datalabels: {
            color: "#fff",
            font: {
              weight: "700",
              size: 15,
            },
            formatter: (value, context) => {
              let percentage = ((value / total) * 100).toFixed(1) + "%";
              return percentage;
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);
    gsap.utils.toArray(".carrs__want").forEach((element) => {
      gsap.to(element, {
        translateX: -800,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          end: "bottom 20%",
          scrub: 2.5,
        },
      });
      gsap.to(element, {
        y: -5,
        duration: 0.6,
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector(".TopScroll");
    window.addEventListener("scroll", function () {
      if (window.scrollY > 300) {
        btn.classList.add("show");
      } else {
        btn.classList.remove("show");
      }
    });

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
}
// {
//   document.addEventListener("DOMContentLoaded", function () {
//     var isCustomizer = window.Shopify && window.Shopify.designMode;
//     if (!isCustomizer) {
//       var aosCSS = document.createElement("link");
//       aosCSS.rel = "stylesheet";
//       aosCSS.href = "https://unpkg.com/aos@2.3.1/dist/aos.css";
//       document.head.appendChild(aosCSS);
//       var aosScript = document.createElement("script");
//       aosScript.src = "https://unpkg.com/aos@2.3.1/dist/aos.js";
//       aosScript.onload = function () {
//         AOS.init();
//       };
//       document.body.appendChild(aosScript);
//     } else {
//       document.querySelectorAll("[data-aos]").forEach(function (el) {
//         el.style.opacity = "1";
//         el.style.transform = "none";
//       });
//     }
//   });
// }
{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".maiN_prnt_video");
    const allVideos = document.querySelectorAll(".maiN_prnt_video video");
    function pauseAllVideos() {
      allVideos.forEach((video) => {
        video.pause();
        const playIcon = video
          .closest(".maiN_prnt_video")
          .querySelector(".vid-play-pause-par");
        playIcon.style.display = "block";
      });
    }
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const playIcon = box.querySelector(".vid-play-pause-par");
      box.addEventListener("click", function () {
        if (video.paused) {
          pauseAllVideos();
          video.play();
          playIcon.style.display = "none";
        } else {
          video.pause();
          playIcon.style.display = "flex";
        }
      });
      video.addEventListener("play", function () {
        playIcon.style.display = "none";
      });
      video.addEventListener("pause", function () {
        playIcon.style.display = "flex";
      });
    });
  });
}
// {
//   document.addEventListener("DOMContentLoaded", function () {
//     AOS.init();
//   });
// }

{
  document.addEventListener("DOMContentLoaded", function () {
    let currencySelector = document.querySelector(".currency-list-btn");
    let currencyList = document.querySelector("#CurrencyList-toolbar");
    const allCurrency = document.querySelectorAll(
      ".ann-toolbar #CurrencyList-toolbar .disclosure-list__option"
    );
    if (currencyList != undefined && currencySelector != undefined) {
      console.log("list found");
      currencySelector.addEventListener("click", () => {
        console.log("list clicked.. found .. classed added");
        if (!currencyList.classList.contains("disclosure-list--visible")) {
          currencyList.classList.add("disclosure-list--visible");
          allCurrency.forEach((curr, ind) => {
            curr.addEventListener("click", () => {
              document
                .querySelectorAll(
                  ".toolbar  #CurrencyList-toolbar .disclosure-list__option"
                )
                [ind].click();
            });
          });
        } else {
          currencyList.classList.remove("disclosure-list--visible");
        }
      });
    }
  });
}
document.querySelectorAll(".animates_text").forEach(el => {
  el.classList.remove("animates_text");
});
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("body *").forEach(el => {
    if (el.childNodes.length) {
      el.childNodes.forEach(node => {
        if (node.nodeType === 3) { 
          node.nodeValue = node.nodeValue.replace(/\u00A0/g, " "); 
        }
      });
    }
  });
});

window.addEventListener('load', () => {
    const reviewBodies = document.querySelectorAll('.oke-reviewContent');

    reviewBodies.forEach(body => {
        const btn = body.querySelector('.oke-reviewContent-readMore');

        // Get the inline height (as number)
        const height = parseFloat(body.querySelector('.oke-reviewContent-body').style.height);

        if (height < 50) {
            btn.style.display = 'none'; 
        }
    });
});


{
//   document.addEventListener("DOMContentLoaded", function () {
//   const timer = document.querySelector(".datapage_line");
//   if (!timer) return;

//   const dateAttr = timer.getAttribute("data-datess");

//   // Parse target date as AEDT (Australia/Sydney) time
//   const targetDate = new Date(
//     new Date(dateAttr + " GMT+11").toLocaleString("en-US", { timeZone: "Australia/Sydney" })
//   ).getTime();

//   const daysEl = timer.querySelector(".dayss");
//   const hoursEl = timer.querySelector(".hourss");
//   const minutesEl = timer.querySelector(".minutess");
//   const secondsEl = timer.querySelector(".secondss");

//   // Get current time in Sydney
//   function getAustraliaNow() {
//     return new Date(
//       new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" })
//     ).getTime();
//   }

//   function updateTimer() {
//     const now = getAustraliaNow();
//     const distance = targetDate - now;

//     if (distance <= 0) {
//       daysEl.textContent = "00";
//       hoursEl.textContent = "00";
//       minutesEl.textContent = "00";
//       secondsEl.textContent = "00";
//       clearInterval(timerInterval);
//       return;
//     }

//     const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//     const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//     const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((distance % (1000 * 60)) / 1000);

//     daysEl.textContent = String(days).padStart(2, "0");
//     hoursEl.textContent = String(hours).padStart(2, "0");
//     minutesEl.textContent = String(minutes).padStart(2, "0");
//     secondsEl.textContent = String(seconds).padStart(2, "0");
//   }

//   updateTimer();
//   const timerInterval = setInterval(updateTimer, 1000);
// });
}